import { render, staticRenderFns } from "./ChapuzonView.vue?vue&type=template&id=ce3e22c4&"
import script from "./ChapuzonView.vue?vue&type=script&lang=ts&"
export * from "./ChapuzonView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports